export default __webpack_public_path__ + "static/media/available-app-store.35ff39d1.png";